import i18nBase, { StringMap } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import {
  initReactI18next,
  useTranslation as useTranslationBase,
} from 'react-i18next';

import en from 'app/locales/en.json';
import lt from 'app/locales/lt.json';
import lv from 'app/locales/lv.json';
import ee from 'app/locales/ee.json';

export const defaultNS = 'translation';

export const resources = {
  en: {
    [defaultNS]: en,
  },
  lt: {
    [defaultNS]: lt,
  },
  lv: {
    [defaultNS]: lv,
  },
  ee: {
    [defaultNS]: ee,
  },
} as const;

i18nBase
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    resources,
    detection: {
      order: [
        'querystring',
        'cookie',
        'localStorage',
        'sessionStorage',
        'htmlTag',
      ],
    },
  });

// i18n type override until i18next types are figured out
export const i18n = i18nBase as {
  t: (key: string, options?: StringMap) => string;
};

// useTranslation type override until i18next types are figured out
export const useTranslation = useTranslationBase as () => {
  t: (key: string, options?: StringMap) => string;
};
